import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyEnableSmsVerification',
  initialState: false,
  reducers: {
    setLoyaltyEnableSmsVerification(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyEnableSmsVerification } = slice.actions;

export default slice.reducer;
